import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::SaasSharedUiShim @className=\"disable-all-glass-global-css invite-banner\" @componentName=\"InviteBanner\" @feature={{this.feature}} @shimTag={{this.shimTag}} />", {
  moduleName: "@dashboard/shared-ui/components/saas/invite-banner.hbs"
});